



















import AutoComplete from "@/components/inputs/AutoComplete.vue"
import Combobox from "@/components/inputs/Combobox.vue"
import AvailableYearModule from "@/store/modules/AvailableYearModule"
import GlobalIndicatorsModule from "@/store/modules/GlobalIndicatorsModule"
import { Component, Vue } from "vue-property-decorator"
import GlobalIndicatorsService from "@/services/globalIndicators/globalIndicatorsService"

@Component({
  components: {
    Combobox,
    AutoComplete
  }
})
export default class GlobalIndicatorsToolbar extends Vue {
  loadingClearCache = false
  isAsyncCache: { display: boolean; error: boolean } = { display: false, error: false }

  get years(): number[] {
    const years = []
    for (const year of AvailableYearModule.years) {
      years.push(year.year)
    }
    return years
  }
  get selectedYear(): number | null {
    return GlobalIndicatorsModule.selectedYear
  }

  set selectedYear(year: number | null) {
    GlobalIndicatorsModule.updateSelectedYear(year)
  }

  get regionsNames(): string[] | undefined {
    return GlobalIndicatorsModule.dataset?.regionsNames
  }

  get selectedRegion(): string | null {
    return GlobalIndicatorsModule.selectedRegion
  }

  set selectedRegion(region: string | null) {
    GlobalIndicatorsModule.updateSelectedRegion(region)
  }

  get countriesList(): string[] | null {
    return GlobalIndicatorsModule.selectableCountriesList
  }

  get selectedCountry(): string | null {
    return GlobalIndicatorsModule.selectedCountry
  }

  set selectedCountry(country: string | null) {
    GlobalIndicatorsModule.updateSelectedCountry(country)
  }

  get dutyStationsList(): string[] | null {
    return GlobalIndicatorsModule.selectableDutyStationsList
  }

  get selectedDutyStation(): string | null {
    return GlobalIndicatorsModule.selectedDutyStation
  }

  set selectedDutyStation(template: string | null) {
    GlobalIndicatorsModule.updateSelectedDutyStation(template)
  }

  async clearCache(): Promise<void> {
    this.loadingClearCache = true
    const result = await GlobalIndicatorsService.clearCache(GlobalIndicatorsModule.filters)
    console.log("GlobalIndicatorsToolbar.clearCache result: ", result)
    this.isAsyncCache = { display: result as boolean, error: !result }
    setTimeout(() => {
      this.isAsyncCache = { display: false, error: false }
    }, 5000)
    this.loadingClearCache = false
    GlobalIndicatorsModule.resetFilters()
  }

  get asyncExportedMessage(): string {
    if (!this.isAsyncCache.error) {
      return "The data update is ongoing. You will receive a notification when the update is completed."
    } else {
      return "The export has failed."
    }
  }

  get asyncExportedStatus(): string {
    if (!this.isAsyncCache.error) {
      return "success"
    } else {
      return "error"
    }
  }

  get hasAlert(): boolean {
    return this.isAsyncCache.display || this.isAsyncCache.error
  }
}
